var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',{attrs:{"fluid":""}},[_c('v-flex',[_vm._t("page-header"),_c('v-row',{staticClass:"user-management-root-wrapper",attrs:{"no-gutters":""}},[_c('v-col',{staticClass:"user-management-item-wrapper"},[_vm._t("user-management-item")],2)],1)],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }